export class CostType {
  public static VOID_ID = 4;
  public static VOID_NAME = 'Void';

  public static ONE_MINUTE = 1;
  public static TWO_MINUTES = 2;
  public static THREE_MINUTES = 3;

  public id: number;
  public costTypeId: number;
  public code: string;
  public name: string;
  public group: number;
}
